export default __webpack_public_path__ + "static/media/arrow-up-black.16dffba2.svg";